import { useMutation } from '@tanstack/react-query';

import { ExpireVoucherUserResponse, expireVoucherUser } from '~/services/PromoService';

export function useExpireVoucherUser() {
  return useMutation<ExpireVoucherUserResponse, Error, string>({
    mutationFn: async (voucherUserId) => expireVoucherUser(voucherUserId),
  });
}
